module.exports = __webpack_public_path__ + "b3204fcd01474538862c7d351925ca5f.svg";